import { render } from "./BrandBlock.vue?vue&type=template&id=926f3b28&scoped=true"
import script from "./BrandBlock.vue?vue&type=script&lang=js"
export * from "./BrandBlock.vue?vue&type=script&lang=js"

import "./BrandBlock.vue?vue&type=style&index=0&id=926f3b28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-926f3b28"]])

export default __exports__